import React from "react";
import { observer } from "mobx-react";
import { WorkAuthorViewStore } from "../../store";
import { WorkAuthorViewForm } from "./WorkAuthorViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type WorkAuthorViewProps = {
  workAuthorViewStore: WorkAuthorViewStore;
};

export const WorkAuthorView: React.FC<WorkAuthorViewProps> = observer(
  ({ workAuthorViewStore }) => {
    return (
      <div>
        <WorkAuthorViewForm
          authorValue={workAuthorViewStore.authorValue}
          lyricsPercentage={workAuthorViewStore.lyricsPercentageValue}
          musicPercentage={workAuthorViewStore.musicPercentageValue}
          publishersVisibleColumns={
            workAuthorViewStore.publishersVisibleColumns
          }
          publishersSetColumnWiths={(x) =>
            workAuthorViewStore.publishersSetColumnWiths(x)
          }
          publishersRows={workAuthorViewStore.publishersRowsDyn}
          onPrint={(handlePrint: () => void) =>
            workAuthorViewStore.printWorkAuthor(handlePrint)
          }
          onCancel={() => workAuthorViewStore.cancelWorkAuthor()}
          onEdit={
            workAuthorViewStore.isEditEnabled
              ? () => workAuthorViewStore.editWorkAuthor()
              : undefined
          }
          viewFormAuthor={() => workAuthorViewStore.viewFormAuthor()}
        />
        <ErrorDialog
          open={workAuthorViewStore.errorDialogOpened}
          title={workAuthorViewStore.errorTitle}
          description={workAuthorViewStore.errorDescription}
          onClose={() => workAuthorViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
